<template>
  <div class="the-article-header">
    <div class="the-article-header__bg-color"></div>
    <div class="the-article-header__wave-blue"><SvgSymbol use="#pepper-article-wave-blue"/></div>
    <div class="the-article-header__wave-fuchsia"><SvgSymbol use="#pepper-article-wave-fuchsia"/></div>
    <div class="the-article-header__logotype" @click="onLogoTypeClick"><SvgSymbol use="#pepper-article-logo"/></div>
  </div>
</template>

<script>
export default {
  name: 'TheArticleHeader',
  methods: {
    onLogoTypeClick () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss">
.the-article-header {
  @include use-layer(&);
  position: relative;

  &:after {
    @include rwd($RWD_DESKTOP) {
      z-index: 1;
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 50%;
      width: 690px;
      height: 0;
      margin-left: -700px;
      border-top: 1px solid #cccccc;
      transform-origin: top right;
      transform: rotate(-45deg);
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 848px;
      margin-left: -700px;
      transform: translate(-30%, 0) rotate(-45deg);
    }
  }

  .svg-symbol {
    position: absolute;
    top: 0;
    left: 0;
  }

  &__bg-color {
    height: 45px;
    background: #6a80d3;
    @include rwd($RWD_TABLET_SMALL) {}
    @include rwd($RWD_TABLET) {
      height: 35px;
    }
    @include rwd($RWD_DESKTOP) {
      height: 40px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      height: 55px;
    }
  }

  &__wave-blue {
    z-index: 1;
    position: absolute;
    width: 100%;
    @include use-fixed-ratio(1111, 264);
  }

  &__wave-fuchsia {
    position: relative;
    margin-top: 15px;
    width: 100%;
    @include use-fixed-ratio(1111, 264);
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 25px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 35px;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 25px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 40px;
    }
  }

  &__logotype {
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 51.88%;
    max-width: 200px;
    margin-top: -15px;
    transform: translate(-50%, -50%);
    cursor: pointer;
    @include use-fixed-ratio(462, 179);
    @include rwd($RWD_TABLET_SMALL) {
      width: 38.46%;
      max-width: 233px;
      margin-top: -25px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: -35px;
    }
    @include rwd($RWD_DESKTOP) {
      top: 36px;
      left: 103px;
      width: 213px;
      max-width: none;
      margin: 0;
      transform: none;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      top: 34px;
      left: 140px;
      width: 242px;
    }
  }
}
</style>
